import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary } from '@material-ui/core';
import Moment from 'moment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from '../../ime-response-summary/ImeResponseSummary.Styles';
import ReferralStatusEntity from '../../../../../entities/ReferralStatus.Entity';
import { ReferralOverviewFcmDataModel } from '../../../../../data-models/ReferralOverviewFcm.DataModel';
import ReferralScheduleStatusTypeEntity from '../../../../../entities/ReferralScheduleStatusType.Entity';
import { ReferralScheduleStatusTypesEnum } from '../../../../../support/enums/ReferralScheduleStatusTypesEnum';

interface IFcmResponseSummaryProps {
    referralStatus: ReferralStatusEntity;
    referralOverviewFcmDataModel: ReferralOverviewFcmDataModel;
    referralScheduleStatusTypes: Array<ReferralScheduleStatusTypeEntity>;
}

export const FcmResponseSummary: FunctionComponent<IFcmResponseSummaryProps> = (props: IFcmResponseSummaryProps) => {
    const classes = styles();

    const schedule = props.referralOverviewFcmDataModel?.schedule;
    const scheduleStatusLabel = props.referralScheduleStatusTypes?.find(
        (x) => x.referralScheduleStatusTypeId === schedule?.referralScheduleStatusTypeId,
    )?.referralScheduleStatusTypeLabel;

    let claimantAttended = '';
    if (schedule?.referralScheduleStatusTypeId === ReferralScheduleStatusTypesEnum.Completed) {
        claimantAttended = 'Yes';
    } else if (
        schedule?.referralScheduleStatusTypeId === ReferralScheduleStatusTypesEnum.ClaimantNotAttended ||
        schedule?.referralScheduleStatusTypeId === ReferralScheduleStatusTypesEnum.UnableToExamine
    ) {
        claimantAttended = 'No';
    }

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                aria-controls="fcm-response-content"
                id="fcm-response-accordion"
                className={classes.paperHeader}
            >
                <Typography variant="subtitle2" className={classes.paperTitle}>
                    FCM
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Referral Status
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.referralStatus?.referralStatusLabel}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Claimant Verified They Will Attend
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {schedule?.attendanceVerifiedDate
                                ? `Yes - ${Moment(schedule.attendanceVerifiedDate).format('MM/DD/YYYY')}`
                                : 'No'}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Claimant Attended
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {claimantAttended}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Schedule Date &amp; Time
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {schedule?.scheduledDate
                                ? `${Moment(schedule.scheduledDate).format('MM/DD/YYYY')} at ${Moment(
                                      schedule.scheduledDate,
                                  ).format('HH:mm')}`
                                : ''}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Schedule Status
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {scheduleStatusLabel}
                        </Typography>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};
